import React from "react";
import PropTypes from "prop-types";
import parse from "html-react-parser";
import { TooltipTrigger } from "@visiblethread/react-components/dist/components/Tooltip";

const IconWithTooltip = ({ icon, tooltipText }) => {
  return <TooltipTrigger content={parse(tooltipText)}>{icon}</TooltipTrigger>;
};

IconWithTooltip.propTypes = {
  icon: PropTypes.node.isRequired,
  tooltipText: PropTypes.string.isRequired,
};

export default IconWithTooltip;
